import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/icons/edit.svg'
import _imports_1 from '@/assets/icons/trash.svg'
import _imports_2 from '@/assets/icons/chevron-right-gray.svg'
import _imports_3 from '@/assets/icons/close.svg'


const _hoisted_1 = { class: "interior-colours-view" }
const _hoisted_2 = {
  key: 0,
  class: "spinner-wrap"
}
const _hoisted_3 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_4 = {
  key: 1,
  class: "schemes-list"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "scheme-row-left" }
const _hoisted_7 = { class: "scheme-info" }
const _hoisted_8 = { class: "scheme-name" }
const _hoisted_9 = { class: "scheme-subtitle" }
const _hoisted_10 = { class: "scheme-row-right" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "detail-back-row" }
const _hoisted_14 = { class: "scheme-header" }
const _hoisted_15 = { class: "scheme-header-text" }
const _hoisted_16 = { class: "scheme-title" }
const _hoisted_17 = {
  key: 0,
  class: "scheme-desc"
}
const _hoisted_18 = { class: "section" }
const _hoisted_19 = {
  key: 0,
  class: "media-grid"
}
const _hoisted_20 = { class: "media-card-img" }
const _hoisted_21 = ["src"]
const _hoisted_22 = {
  key: 1,
  class: "media-card-placeholder"
}
const _hoisted_23 = { class: "media-card-footer" }
const _hoisted_24 = { class: "media-card-name" }
const _hoisted_25 = { class: "media-card-actions" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = {
  key: 1,
  class: "section-empty"
}
const _hoisted_29 = { class: "section" }
const _hoisted_30 = {
  key: 0,
  class: "media-grid media-grid--sm"
}
const _hoisted_31 = { class: "media-card-img" }
const _hoisted_32 = ["src"]
const _hoisted_33 = {
  key: 1,
  class: "media-card-placeholder"
}
const _hoisted_34 = { class: "media-card-footer" }
const _hoisted_35 = { class: "media-card-name" }
const _hoisted_36 = {
  key: 0,
  class: "media-card-desc"
}
const _hoisted_37 = { class: "media-card-actions" }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = ["onClick"]
const _hoisted_40 = {
  key: 1,
  class: "section-empty"
}
const _hoisted_41 = { class: "modal-content" }
const _hoisted_42 = { class: "modal-header" }
const _hoisted_43 = { class: "modal-title" }
const _hoisted_44 = { class: "modal-body" }
const _hoisted_45 = { class: "form-group" }
const _hoisted_46 = { class: "form-group" }
const _hoisted_47 = { class: "modal-footer" }
const _hoisted_48 = ["disabled"]
const _hoisted_49 = { class: "modal-content" }
const _hoisted_50 = { class: "modal-header" }
const _hoisted_51 = { class: "modal-title" }
const _hoisted_52 = { class: "modal-body" }
const _hoisted_53 = { class: "form-group" }
const _hoisted_54 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_55 = { class: "form-group" }
const _hoisted_56 = { class: "upload-row" }
const _hoisted_57 = ["src"]
const _hoisted_58 = { class: "modal-footer" }
const _hoisted_59 = ["disabled"]
const _hoisted_60 = { class: "modal-content" }
const _hoisted_61 = { class: "modal-header" }
const _hoisted_62 = { class: "modal-title" }
const _hoisted_63 = { class: "modal-body" }
const _hoisted_64 = { class: "form-group" }
const _hoisted_65 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_66 = { class: "form-group" }
const _hoisted_67 = { class: "form-group" }
const _hoisted_68 = { class: "upload-row" }
const _hoisted_69 = ["src"]
const _hoisted_70 = { class: "modal-footer" }
const _hoisted_71 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.view === 'list')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", { class: "view-header" }, [
            _cache[8] || (_cache[8] = _createElementVNode("h2", { class: "title-main" }, "Colour Schemes", -1)),
            _createElementVNode("button", {
              class: "button default primary",
              onClick: $setup.openCreateModal
            }, "+ Create Scheme")
          ]),
          ($setup.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[9] || (_cache[9] = [
                _createElementVNode("div", { class: "spinner" }, null, -1)
              ]))]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                ($setup.schemes.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[10] || (_cache[10] = [
                      _createStaticVNode("<div class=\"empty-icon-wrap\" data-v-8c09262a><svg viewBox=\"0 0 24 24\" fill=\"none\" width=\"48\" height=\"48\" data-v-8c09262a><path d=\"M12 3a9 9 0 1 0 9 9\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" data-v-8c09262a></path><circle cx=\"7\" cy=\"11.5\" r=\"1.5\" fill=\"currentColor\" data-v-8c09262a></circle><circle cx=\"10\" cy=\"7.5\" r=\"1.5\" fill=\"currentColor\" data-v-8c09262a></circle><circle cx=\"14\" cy=\"7.5\" r=\"1.5\" fill=\"currentColor\" data-v-8c09262a></circle><circle cx=\"17\" cy=\"11.5\" r=\"1.5\" fill=\"currentColor\" data-v-8c09262a></circle></svg></div><p class=\"empty-text\" data-v-8c09262a>No colour schemes yet</p><p class=\"empty-hint\" data-v-8c09262a>Click &quot;Create Scheme&quot; to get started</p>", 3)
                    ]))]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.schemes, (scheme) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "scheme-row",
                          key: scheme._id,
                          onClick: ($event: any) => ($setup.openDetail(scheme))
                        }, [
                          _createElementVNode("div", _hoisted_6, [
                            _cache[11] || (_cache[11] = _createStaticVNode("<div class=\"scheme-icon-wrap\" data-v-8c09262a><svg class=\"scheme-icon\" viewBox=\"0 0 24 24\" fill=\"none\" data-v-8c09262a><path d=\"M12 3a9 9 0 1 0 9 9\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" data-v-8c09262a></path><circle cx=\"7\" cy=\"11.5\" r=\"1.2\" fill=\"currentColor\" data-v-8c09262a></circle><circle cx=\"10\" cy=\"7.5\" r=\"1.2\" fill=\"currentColor\" data-v-8c09262a></circle><circle cx=\"14\" cy=\"7.5\" r=\"1.2\" fill=\"currentColor\" data-v-8c09262a></circle><circle cx=\"17\" cy=\"11.5\" r=\"1.2\" fill=\"currentColor\" data-v-8c09262a></circle></svg></div>", 1)),
                            _createElementVNode("div", _hoisted_7, [
                              _createElementVNode("span", _hoisted_8, _toDisplayString(scheme.name), 1),
                              _createElementVNode("span", _hoisted_9, _toDisplayString(scheme.description || "No description"), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("button", {
                              class: "action-btn",
                              type: "button",
                              onClick: _withModifiers(($event: any) => ($setup.openEditModal(scheme)), ["stop"]),
                              title: "Edit"
                            }, [...(_cache[12] || (_cache[12] = [
                              _createElementVNode("img", {
                                src: _imports_0,
                                alt: "Edit"
                              }, null, -1)
                            ]))], 8, _hoisted_11),
                            _createElementVNode("button", {
                              class: "action-btn danger",
                              type: "button",
                              onClick: _withModifiers(($event: any) => ($setup.confirmDeleteScheme(scheme)), ["stop"]),
                              title: "Delete"
                            }, [...(_cache[13] || (_cache[13] = [
                              _createElementVNode("img", {
                                src: _imports_1,
                                alt: "Delete"
                              }, null, -1)
                            ]))], 8, _hoisted_12),
                            _cache[14] || (_cache[14] = _createElementVNode("img", {
                              class: "chevron-icon",
                              src: _imports_2,
                              alt: ""
                            }, null, -1))
                          ])
                        ], 8, _hoisted_5))
                      }), 128))
                    ]))
              ], 64))
        ], 64))
      : _createCommentVNode("", true),
    ($setup.view === 'detail' && $setup.selectedScheme)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("button", {
              class: "back-btn",
              type: "button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.view = 'list'))
            }, [...(_cache[15] || (_cache[15] = [
              _createElementVNode("svg", {
                viewBox: "0 0 24 24",
                fill: "none",
                width: "14",
                height: "14"
              }, [
                _createElementVNode("path", {
                  d: "M15 18l-6-6 6-6",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                })
              ], -1),
              _createElementVNode("span", null, "Back to Schemes", -1)
            ]))])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _cache[16] || (_cache[16] = _createStaticVNode("<div class=\"scheme-header-icon\" data-v-8c09262a><svg viewBox=\"0 0 24 24\" fill=\"none\" width=\"22\" height=\"22\" data-v-8c09262a><path d=\"M12 3a9 9 0 1 0 9 9\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" data-v-8c09262a></path><circle cx=\"7\" cy=\"11.5\" r=\"1\" fill=\"currentColor\" data-v-8c09262a></circle><circle cx=\"10\" cy=\"7.5\" r=\"1\" fill=\"currentColor\" data-v-8c09262a></circle><circle cx=\"14\" cy=\"7.5\" r=\"1\" fill=\"currentColor\" data-v-8c09262a></circle><circle cx=\"17\" cy=\"11.5\" r=\"1\" fill=\"currentColor\" data-v-8c09262a></circle></svg></div>", 1)),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("h2", _hoisted_16, _toDisplayString($setup.selectedScheme.name), 1),
              ($setup.selectedScheme.description)
                ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString($setup.selectedScheme.description), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", { class: "section-header" }, [
              _cache[17] || (_cache[17] = _createStaticVNode("<div class=\"section-header-left\" data-v-8c09262a><svg class=\"section-icon\" viewBox=\"0 0 24 24\" fill=\"none\" width=\"18\" height=\"18\" data-v-8c09262a><rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"2\" stroke=\"currentColor\" stroke-width=\"1.5\" data-v-8c09262a></rect><circle cx=\"8.5\" cy=\"8.5\" r=\"1.5\" stroke=\"currentColor\" stroke-width=\"1.5\" data-v-8c09262a></circle><path d=\"M21 15l-5-5L5 21\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" data-v-8c09262a></path></svg><h3 class=\"section-title\" data-v-8c09262a>Room Images</h3></div>", 1)),
              _createElementVNode("button", {
                class: "button default primary",
                onClick: $setup.openAddRoomImageModal
              }, "+ Add Image")
            ]),
            ($setup.localRoomImages.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.localRoomImages, (img, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "media-card",
                      key: idx
                    }, [
                      _createElementVNode("div", _hoisted_20, [
                        (img.url)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: img.url,
                              alt: ""
                            }, null, 8, _hoisted_21))
                          : (_openBlock(), _createElementBlock("div", _hoisted_22, [...(_cache[18] || (_cache[18] = [
                              _createElementVNode("svg", {
                                viewBox: "0 0 24 24",
                                fill: "none",
                                width: "36",
                                height: "36"
                              }, [
                                _createElementVNode("rect", {
                                  x: "3",
                                  y: "3",
                                  width: "18",
                                  height: "18",
                                  rx: "2",
                                  stroke: "currentColor",
                                  "stroke-width": "1.5"
                                }),
                                _createElementVNode("circle", {
                                  cx: "8.5",
                                  cy: "8.5",
                                  r: "1.5",
                                  stroke: "currentColor",
                                  "stroke-width": "1.5"
                                }),
                                _createElementVNode("path", {
                                  d: "M21 15l-5-5L5 21",
                                  stroke: "currentColor",
                                  "stroke-width": "1.5",
                                  "stroke-linecap": "round"
                                })
                              ], -1)
                            ]))]))
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("span", _hoisted_24, _toDisplayString(img.name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("button", {
                          class: "action-btn-sm",
                          type: "button",
                          onClick: _withModifiers(($event: any) => ($setup.openEditRoomImageModal(img, idx)), ["stop"])
                        }, [...(_cache[19] || (_cache[19] = [
                          _createElementVNode("img", {
                            src: _imports_0,
                            alt: "Edit"
                          }, null, -1)
                        ]))], 8, _hoisted_26),
                        _createElementVNode("button", {
                          class: "action-btn-sm danger",
                          type: "button",
                          onClick: _withModifiers(($event: any) => ($setup.confirmDeleteRoomImage(idx)), ["stop"])
                        }, [...(_cache[20] || (_cache[20] = [
                          _createElementVNode("img", {
                            src: _imports_1,
                            alt: "Delete"
                          }, null, -1)
                        ]))], 8, _hoisted_27)
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_28, [...(_cache[21] || (_cache[21] = [
                  _createElementVNode("p", null, "No room images yet", -1)
                ]))]))
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", { class: "section-header" }, [
              _cache[22] || (_cache[22] = _createStaticVNode("<div class=\"section-header-left\" data-v-8c09262a><svg class=\"section-icon\" viewBox=\"0 0 24 24\" fill=\"none\" width=\"18\" height=\"18\" data-v-8c09262a><path d=\"M12 2L2 7l10 5 10-5-10-5z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-8c09262a></path><path d=\"M2 17l10 5 10-5\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-8c09262a></path><path d=\"M2 12l10 5 10-5\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-8c09262a></path></svg><h3 class=\"section-title\" data-v-8c09262a>Product Materials</h3><span class=\"optional-label\" data-v-8c09262a>(optional)</span></div>", 1)),
              _createElementVNode("button", {
                class: "button default primary",
                onClick: $setup.openAddMaterialModal
              }, "+ Add Material")
            ]),
            ($setup.localMaterials.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.localMaterials, (mat, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "media-card",
                      key: idx
                    }, [
                      _createElementVNode("div", _hoisted_31, [
                        (mat.url)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: mat.url,
                              alt: ""
                            }, null, 8, _hoisted_32))
                          : (_openBlock(), _createElementBlock("div", _hoisted_33, [...(_cache[23] || (_cache[23] = [
                              _createElementVNode("svg", {
                                viewBox: "0 0 24 24",
                                fill: "none",
                                width: "36",
                                height: "36"
                              }, [
                                _createElementVNode("path", {
                                  d: "M12 2L2 7l10 5 10-5-10-5z",
                                  stroke: "currentColor",
                                  "stroke-width": "1.5",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round"
                                }),
                                _createElementVNode("path", {
                                  d: "M2 17l10 5 10-5",
                                  stroke: "currentColor",
                                  "stroke-width": "1.5",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round"
                                }),
                                _createElementVNode("path", {
                                  d: "M2 12l10 5 10-5",
                                  stroke: "currentColor",
                                  "stroke-width": "1.5",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round"
                                })
                              ], -1)
                            ]))]))
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("span", _hoisted_35, _toDisplayString(mat.name), 1),
                        (mat.description)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(mat.description), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("button", {
                          class: "action-btn-sm",
                          type: "button",
                          onClick: _withModifiers(($event: any) => ($setup.openEditMaterialModal(mat, idx)), ["stop"])
                        }, [...(_cache[24] || (_cache[24] = [
                          _createElementVNode("img", {
                            src: _imports_0,
                            alt: "Edit"
                          }, null, -1)
                        ]))], 8, _hoisted_38),
                        _createElementVNode("button", {
                          class: "action-btn-sm danger",
                          type: "button",
                          onClick: _withModifiers(($event: any) => ($setup.confirmDeleteMaterial(idx)), ["stop"])
                        }, [...(_cache[25] || (_cache[25] = [
                          _createElementVNode("img", {
                            src: _imports_1,
                            alt: "Delete"
                          }, null, -1)
                        ]))], 8, _hoisted_39)
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_40, [...(_cache[26] || (_cache[26] = [
                  _createElementVNode("p", null, "No product materials added", -1)
                ]))]))
          ])
        ], 64))
      : _createCommentVNode("", true),
    ($setup.showSchemeModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "modal-overlay",
          onClick: _withModifiers($setup.closeSchemeModal, ["self"])
        }, [
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("h3", _hoisted_43, _toDisplayString($setup.isEditSchemeMode ? "Edit Colour Scheme" : "Create Colour Scheme"), 1),
              _createElementVNode("button", {
                class: "modal-close",
                type: "button",
                onClick: $setup.closeSchemeModal
              }, [...(_cache[27] || (_cache[27] = [
                _createElementVNode("img", {
                  src: _imports_3,
                  alt: "Close"
                }, null, -1)
              ]))])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _cache[28] || (_cache[28] = _createElementVNode("label", { class: "form-label" }, "Scheme Name", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: "input",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.schemeForm.name) = $event)),
                  placeholder: "e.g. Classic Neutrals",
                  onKeyup: _withKeys($setup.saveScheme, ["enter"])
                }, null, 544), [
                  [_vModelText, $setup.schemeForm.name]
                ])
              ]),
              _createElementVNode("div", _hoisted_46, [
                _cache[29] || (_cache[29] = _createElementVNode("label", { class: "form-label" }, "Description (optional)", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  class: "input textarea-field",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.schemeForm.description) = $event)),
                  placeholder: "A brief description of the colour palette",
                  rows: "3"
                }, null, 512), [
                  [_vModelText, $setup.schemeForm.description]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("button", {
                class: "button default cancel",
                type: "button",
                onClick: $setup.closeSchemeModal
              }, "Cancel"),
              _createElementVNode("button", {
                class: "button default primary",
                type: "button",
                disabled: !$setup.schemeForm.name.trim() || $setup.savingScheme,
                onClick: $setup.saveScheme
              }, _toDisplayString($setup.isEditSchemeMode ? "Save Changes" : "Create"), 9, _hoisted_48)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    ($setup.showRoomImageModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "modal-overlay",
          onClick: _withModifiers($setup.closeRoomImageModal, ["self"])
        }, [
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("h3", _hoisted_51, _toDisplayString($setup.isEditRoomImageMode ? "Edit Room Image" : "Add Room Image"), 1),
              _createElementVNode("button", {
                class: "modal-close",
                type: "button",
                onClick: $setup.closeRoomImageModal
              }, [...(_cache[30] || (_cache[30] = [
                _createElementVNode("img", {
                  src: _imports_3,
                  alt: "Close"
                }, null, -1)
              ]))])
            ]),
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("div", _hoisted_53, [
                _cache[31] || (_cache[31] = _createElementVNode("label", { class: "form-label" }, "Name", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass(["input", { error: $setup.roomImageNameError }]),
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.roomImageForm.name) = $event)),
                  placeholder: "e.g. Kitchen, Bathroom, Living Room"
                }, null, 2), [
                  [_vModelText, $setup.roomImageForm.name]
                ]),
                ($setup.roomImageNameError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_54, "Name is required"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_55, [
                _cache[33] || (_cache[33] = _createElementVNode("label", { class: "form-label" }, "Image", -1)),
                _createElementVNode("div", _hoisted_56, [
                  ($setup.roomImageForm.previewUrl || $setup.roomImageForm.url)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "upload-preview",
                        src: $setup.roomImageForm.previewUrl || $setup.roomImageForm.url,
                        alt: "Preview"
                      }, null, 8, _hoisted_57))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    class: "upload-btn",
                    type: "button",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.roomImageFileInput?.click()))
                  }, [
                    _cache[32] || (_cache[32] = _createElementVNode("svg", {
                      viewBox: "0 0 24 24",
                      fill: "none",
                      width: "15",
                      height: "15"
                    }, [
                      _createElementVNode("path", {
                        d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }),
                      _createElementVNode("polyline", {
                        points: "17 8 12 3 7 8",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }),
                      _createElementVNode("line", {
                        x1: "12",
                        y1: "3",
                        x2: "12",
                        y2: "15",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      })
                    ], -1)),
                    _createElementVNode("span", null, _toDisplayString($setup.roomImageForm.previewUrl || $setup.roomImageForm.url ? "Change File" : "Upload File"), 1)
                  ]),
                  _createElementVNode("input", {
                    type: "file",
                    accept: "image/*",
                    ref: "roomImageFileInput",
                    style: {"display":"none"},
                    onChange: $setup.handleRoomImageFileChange
                  }, null, 544)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("button", {
                class: "button default cancel",
                type: "button",
                onClick: $setup.closeRoomImageModal
              }, "Cancel"),
              _createElementVNode("button", {
                class: "button default primary",
                type: "button",
                disabled: !$setup.roomImageForm.name.trim() || $setup.savingRoomImage,
                onClick: $setup.saveRoomImage
              }, _toDisplayString($setup.isEditRoomImageMode ? "Save Changes" : "Add"), 9, _hoisted_59)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    ($setup.showMaterialModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          class: "modal-overlay",
          onClick: _withModifiers($setup.closeMaterialModal, ["self"])
        }, [
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("h3", _hoisted_62, _toDisplayString($setup.isEditMaterialMode ? "Edit Product Material" : "Add Product Material"), 1),
              _createElementVNode("button", {
                class: "modal-close",
                type: "button",
                onClick: $setup.closeMaterialModal
              }, [...(_cache[34] || (_cache[34] = [
                _createElementVNode("img", {
                  src: _imports_3,
                  alt: "Close"
                }, null, -1)
              ]))])
            ]),
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("div", _hoisted_64, [
                _cache[35] || (_cache[35] = _createElementVNode("label", { class: "form-label" }, "Name", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass(["input", { error: $setup.materialNameError }]),
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.materialForm.name) = $event)),
                  placeholder: "e.g. Benchtop Stone, Floor Tile"
                }, null, 2), [
                  [_vModelText, $setup.materialForm.name]
                ]),
                ($setup.materialNameError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_65, "Name is required"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_66, [
                _cache[36] || (_cache[36] = _createElementVNode("label", { class: "form-label" }, "Description (optional)", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  class: "input textarea-field",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.materialForm.description) = $event)),
                  placeholder: "e.g. 20mm Caesarstone in Linen",
                  rows: "3"
                }, null, 512), [
                  [_vModelText, $setup.materialForm.description]
                ])
              ]),
              _createElementVNode("div", _hoisted_67, [
                _cache[38] || (_cache[38] = _createElementVNode("label", { class: "form-label" }, "Image", -1)),
                _createElementVNode("div", _hoisted_68, [
                  ($setup.materialForm.previewUrl || $setup.materialForm.url)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "upload-preview",
                        src: $setup.materialForm.previewUrl || $setup.materialForm.url,
                        alt: "Preview"
                      }, null, 8, _hoisted_69))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    class: "upload-btn",
                    type: "button",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.materialFileInput?.click()))
                  }, [
                    _cache[37] || (_cache[37] = _createElementVNode("svg", {
                      viewBox: "0 0 24 24",
                      fill: "none",
                      width: "15",
                      height: "15"
                    }, [
                      _createElementVNode("path", {
                        d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }),
                      _createElementVNode("polyline", {
                        points: "17 8 12 3 7 8",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }),
                      _createElementVNode("line", {
                        x1: "12",
                        y1: "3",
                        x2: "12",
                        y2: "15",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      })
                    ], -1)),
                    _createElementVNode("span", null, _toDisplayString($setup.materialForm.previewUrl || $setup.materialForm.url ? "Change File" : "Upload File"), 1)
                  ]),
                  _createElementVNode("input", {
                    type: "file",
                    accept: "image/*",
                    ref: "materialFileInput",
                    style: {"display":"none"},
                    onChange: $setup.handleMaterialFileChange
                  }, null, 544)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_70, [
              _createElementVNode("button", {
                class: "button default cancel",
                type: "button",
                onClick: $setup.closeMaterialModal
              }, "Cancel"),
              _createElementVNode("button", {
                class: "button default primary",
                type: "button",
                disabled: !$setup.materialForm.name.trim() || $setup.savingMaterial,
                onClick: $setup.saveMaterial
              }, _toDisplayString($setup.isEditMaterialMode ? "Save Changes" : "Add"), 9, _hoisted_71)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}